function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Nav, NavItem, NavLink, Progress, TabContent, TabPane, ListGroup, ListGroupItem } from 'reactstrap';
import PropTypes from 'prop-types';
import { AppSwitch } from '@coreui/react';
import classNames from 'classnames';

var propTypes = {
    children: PropTypes.node
};

function toggleClasses(toggleClass, classList, force) {
    var level = classList.indexOf(toggleClass);
    var removeClassList = classList.slice(0, level);
    removeClassList.map(function (className) {
        return document.body.classList.remove(className);
    });
    document.body.classList.toggle(toggleClass, force);
}

var defaultProps = {};

var asideMenuCssClasses = ['aside-menu-show', 'aside-menu-sm-show', 'aside-menu-md-show', 'aside-menu-lg-show', 'aside-menu-xl-show'];

var RXAside = function (_Component) {
    _inherits(RXAside, _Component);

    function RXAside(props) {
        _classCallCheck(this, RXAside);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.componentDidMount = function () {

            _this.actionStoreUnsubscribe = _this.props.actionStore.subscribe(function () {
                var state = _this.props.actionStore.getState();

                switch (state.state) {
                    case _this.props.states.COMPONENT_LOADED:
                        console.log('in aSide Component Loaded');
                        _this.setState({ component: state.component, show: true });
                        _this.showAside();
                        break;
                    case _this.props.states.COMPONENT_UNLOADED:
                        _this.setState({ show: false });
                        _this.hideAside();
                    default:
                        break;
                }
            });
        };

        _this.showAside = function () {
            var display = 'lg';
            var cssTemplate = 'aside-menu-' + display + '-show';
            var _asideMenuCssClasses$ = asideMenuCssClasses[0],
                cssClass = _asideMenuCssClasses$[0];

            if (display && asideMenuCssClasses.indexOf(cssTemplate) > -1) {
                cssClass = cssTemplate;
            }
            document.body.classList.add(cssClass);
        };

        _this.hideAside = function () {
            var display = 'lg';
            var cssTemplate = 'aside-menu-' + display + '-show';
            var _asideMenuCssClasses$2 = asideMenuCssClasses[0],
                cssClass = _asideMenuCssClasses$2[0];

            if (display && asideMenuCssClasses.indexOf(cssTemplate) > -1) {
                cssClass = cssTemplate;
            }
            document.body.classList.remove(cssClass);
        };

        _this.toggleAside = function () {

            var display = 'lg';
            var cssTemplate = 'aside-menu-' + display + '-show';
            var _asideMenuCssClasses$3 = asideMenuCssClasses[0],
                cssClass = _asideMenuCssClasses$3[0];

            if (display && asideMenuCssClasses.indexOf(cssTemplate) > -1) {
                cssClass = cssTemplate;
            }
            console.log('before toggle ' + cssClass + ' and ' + asideMenuCssClasses);
            toggleClasses(cssClass, asideMenuCssClasses);
        };

        _this.toggle = _this.toggle.bind(_this);
        _this.state = {
            activeTab: '4',
            show: false
        };
        return _this;
    }

    RXAside.prototype.toggle = function toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    };

    RXAside.prototype.render = function render() {

        // eslint-disable-next-line
        var _props = this.props,
            children = _props.children,
            attributes = _objectWithoutProperties(_props, ['children']);

        return React.createElement(
            React.Fragment,
            null,
            this.state.component
        );
    };

    return RXAside;
}(Component);

RXAside.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
RXAside.defaultProps = defaultProps;

export default RXAside;